/* 2026-10-25 P3: open the Shopify Inbox chat from "Chat with a SEBO specialist"; fall back to the contact form. */
(() => {
  if (window.avonSpecialistBound) return;
  window.avonSpecialistBound = true;
  const openChat = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return false;
    // Shopify Inbox's <shopify-chat> exposes show()/open() methods ("open" is also a state getter).
    if (typeof chat.show === 'function') { chat.show(); return true; }
    const root = chat.shadowRoot;
    const button = root && (root.querySelector('button[aria-label*="hat" i]') || root.querySelector('button'));
    if (button) { button.click(); return true; }
    return false;
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-av-open-chat]');
    if (!trigger) return;
    event.preventDefault();
    if (!openChat()) { window.location.href = trigger.dataset.fallback; return; }
    // 2026-10-29: if the chat panel still is not visible, use the contact-form fallback.
    setTimeout(() => {
      const chat = document.querySelector('shopify-chat');
      if (!chat || getComputedStyle(chat).display === 'none') window.location.href = trigger.dataset.fallback;
    }, 1200);
  });
})();
